var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "file-upload-list-item d-flex",
      class: { "file-upload-list-item--undo": _vm.removed },
    },
    [
      _vm.removed
        ? _c("div", { staticClass: "va-row" }, [
            _c(
              "div",
              { staticClass: "flex md12 xs12" },
              [
                _c("vuestic-file-upload-undo", {
                  on: { recover: _vm.recoverFile },
                }),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "va-row align--center" }, [
            _c(
              "div",
              {
                staticClass:
                  "file-upload-list-item__name flex xs12 lg8 ellipsis",
                on: {
                  click: function ($event) {
                    return _vm.showImage(_vm.file, true)
                  },
                },
              },
              [
                _c("img", { attrs: { src: _vm.fileImage } }),
                _c("span", [_vm._v(_vm._s(_vm.file.name))]),
              ]
            ),
            _c("div", { staticClass: "file-upload-list-item__size xs12 lg1" }),
            _c("div", { staticClass: "file-upload-list-item__date xs12 lg1" }),
            _c(
              "div",
              {
                staticClass:
                  "file-upload-list-item__button-container flex xs12 lg2",
              },
              [
                !_vm.disabled
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-text btn-text--primary",
                        attrs: { type: "button" },
                        on: { click: _vm.removeFile },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("fileUpload.delete")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
      _c("large-image", {
        attrs: {
          isShowFileImage: _vm.isShowFileImage,
          filesList: _vm.filesList,
          bigImage: _vm.bigImage,
          fileUrl: _vm.fileUrl,
          curFile: _vm.curFile,
        },
        on: {
          closeLargeImage: _vm.closeFileImage,
          showImage: _vm.showImageInit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }